
			import { Motion } from './src/Motion'

			// Theme Management
			const themeToggle = document.getElementById('themeToggle')
			const toggleCircle = themeToggle.querySelector('.toggle-circle')

			// Detect system preference
			const prefersDark = window.matchMedia('(prefers-color-scheme: dark)')

			// Initialize theme
			function initTheme() {
				const savedTheme = localStorage.getItem('theme')
				const systemTheme = prefersDark.matches ? 'dark' : 'light'
				const theme = savedTheme || systemTheme

				setTheme(theme)
			}

			function setTheme(theme) {
				document.documentElement.setAttribute('data-theme', theme)
				localStorage.setItem('theme', theme)
				toggleCircle.textContent = theme === 'dark' ? '☀️' : '🌙'

				// Update motion mode
				if (window.motion) {
					window.motion.dispose()
					createMotion(theme)
				}
			}

			function toggleTheme() {
				const current = document.documentElement.getAttribute('data-theme')
				const newTheme = current === 'dark' ? 'light' : 'dark'
				setTheme(newTheme)
			}

			// Event listeners
			themeToggle.addEventListener('click', toggleTheme)
			prefersDark.addEventListener('change', (e) => {
				if (!localStorage.getItem('theme')) {
					setTheme(e.matches ? 'dark' : 'light')
				}
			})

			// Motion Setup
			function createMotion(mode = 'light') {
				const motion = new Motion({
					width: document.documentElement.clientWidth,
					height: document.documentElement.clientHeight,
					mode: mode,
					styles: {
						position: 'fixed',
						inset: '0',
						zIndex: '1',
					},
				})

				document.body.appendChild(motion.element)

				// Auto-resize on window resize
				window.addEventListener('resize', () =>
					motion.resize(document.documentElement.clientWidth, document.documentElement.clientHeight)
				)

				motion.start()
				motion.fadeIn()

				window.motion = motion
			}

			// Initialize
			initTheme()

			// Create motion with current theme
			const currentTheme = document.documentElement.getAttribute('data-theme')
			createMotion(currentTheme)
		